import { combineReducers } from 'redux'
import { reducer as formReducer } from 'redux-form'

import appReducer, * as fromApp from './app'
import authReducer, * as fromAuth from './auth'
import usersReducer, * as fromUsers from './users'
import artworksReducer, * as fromArtworks from './artworks'
import frameTypesReducer, * as fromFrameTypes from './frameTypes'
import salesReducer, * as fromSales from './sales'
import sizesReducer, * as fromSizes from './sizes'
import tagsReducer, * as fromTags from './tags'
import { SIGNING_UP_SUCCEEDED } from '../actionTypes'

const rootReducer = combineReducers({
  app: appReducer,
  auth: authReducer,
  users: usersReducer,
  artworks: artworksReducer,
  frameTypes: frameTypesReducer,
  sales: salesReducer,
  sizes: sizesReducer,
  tags: tagsReducer,
  form: formReducer.plugin({
    signup: (state, action) => {
      switch (action.type) {
        case SIGNING_UP_SUCCEEDED:
          return undefined
        default:
          return state
      }
    }
  })
})

export default rootReducer

// app reducer selectors

export const getIsLoaded = (state) =>
  fromApp.getIsLoaded(state.app)

export const getShowLoadingOverlay = (state) =>
  fromApp.getShowLoadingOverlay(state.app)

export const getIsFetching = (state) =>
  fromApp.getIsFetching(state.app)

export const getToasts = (state) =>
  fromApp.getToasts(state.app)

// auth reducer selectors

export const getIsAuthenticated = (state) =>
  fromAuth.getIsAuthenticated(state.auth)

export const getIsSigningOut = (state) =>
  fromAuth.getIsSigningOut(state.auth)

export const getAuthUser = (state) =>
  fromAuth.getUser(state.auth)

// users reducer selectors

export const getIsFetchingUsers = (state) =>
  fromUsers.getIsFetching(state.users)

export const getUser = (state, id) =>
  fromUsers.getUser(state.users, id)

export const getUsers = (state) =>
  fromUsers.getUsers(state.users)

export const getProfileUpload = (state) =>
  fromUsers.getProfileUpload(state.users)

// artworks reducer selectors

export const getIsFetchingArtworks = (state) =>
  fromArtworks.getIsFetching(state.artworks)

export const getArtwork = (state, id) =>
  fromArtworks.getArtwork(state.artworks, id)

export const getArtworks = (state, status) =>
  fromArtworks.getArtworks(state.artworks, status)

export const getArtworkPage = (state) =>
  fromArtworks.getArtworkPage(state.artworks)

export const getArtworkRowsPerPage = (state) =>
  fromArtworks.getArtworkRowsPerPage(state.artworks)

export const getArtworkCount = (state, status) =>
  fromArtworks.getArtworkCount(state.artworks, status)

export const getArtworkUploadStatus = (state) =>
  fromArtworks.getArtworkUploadStatus(state.artworks)

export const getArtworkUploads = (state) =>
  fromArtworks.getArtworkUploads(state.artworks)

export const getNextArtworkUpload = (state) =>
  fromArtworks.getNextArtworkUpload(state.artworks)

export const getUploadProgress = (state) =>
  fromArtworks.getUploadProgress(state.artworks)

// tags reducer selectors

export const getIsFetchingTags = (state) =>
  fromTags.getIsFetching(state.tags)

export const getTag = (state, id) =>
  fromTags.getTag(state.tags, id)

export const getTags = (state) =>
  fromTags.getTags(state.tags)

// frameTypes reducer selectors

export const getIsFetchingFrameTypes = (state) =>
  fromFrameTypes.getIsFetching(state.frameTypes)

export const getFrameType = (state, id) =>
  fromFrameTypes.getFrameType(state.frameTypes, id)

export const getFrameTypes = (state) =>
  fromFrameTypes.getFrameTypes(state.frameTypes)

// sizes reducer selectors

export const getIsFetchingSizes = (state) =>
  fromSizes.getIsFetching(state.sizes)

export const getSize = (state, id) =>
  fromSizes.getSize(state.sizes, id)

export const getSizes = (state) =>
  fromSizes.getSizes(state.sizes)

// sizes reducer selectors

export const getIsFetchingSales = (state) =>
  fromSales.getIsFetching(state.sales)

export const getSale = (state, id) =>
  fromSales.getSale(state.sales, id)

export const getSales = (state) =>
  fromSales.getSales(state.sales)

export const getSalePage = (state) =>
  fromSales.getSalePage(state.sales)

export const getSaleRowsPerPage = (state) =>
  fromSales.getSaleRowsPerPage(state.sales)

export const getSaleCount = (state) =>
  fromSales.getSaleCount(state.sales)



// WEBPACK FOOTER //
// ./src/redux/reducers/index.js